import { PropertyValueMap, TemplateResult, html, CSSResultGroup } from 'lit';
import { property, state } from 'lit/decorators.js';
import { BlocksElement } from '../BlocksElement';
import { BlocksImageGalleryThumbnailItem } from '../image-gallery-thumbnail-item';
import type { GalleryThumbnailPosition } from '../image-gallery-thumbnail/image-gallery-thumbnail.model';
import styles from './image-gallery-thumbnail.styles';

/**
 * @slot - The component content
 * @csspart base - The component's base wrapper.
 * @csspart part-default - The component's default slot.
 */
export class BlocksImageGalleryThumbnail extends BlocksElement {static styles: CSSResultGroup = styles;

  @property({ type: String })
  position: GalleryThumbnailPosition;

  /**
   * This property is used to check is small variant is used.
   */
  @state()
  checkSmallVariant = false;

  /**
   * Query all the gallery thumbnail items in the image gallery
   */
  private get _thumbnailItems(): Array<BlocksImageGalleryThumbnailItem> {
    return Array.from(this.querySelectorAll('cat-image-gallery-thumbnail-item'));
  }

  /**
   * function invoked to set SmallView if it is in small view.
   */
  protected firstUpdated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): void {
    this.setSmallView();
  }

  /**
   * To check whether small variant is used,if used then to set true to checkSmallVariant
   */
  private setSmallView() {
    if (this._thumbnailItems) {
      this._thumbnailItems.forEach((item: BlocksImageGalleryThumbnailItem) => {
        if (!this.checkSmallVariant && item.isSmall) {
          this.checkSmallVariant = true;
        }
      });
    }
  }

  render(): TemplateResult<1> {
    const componentClassNames = this.componentClassNames('cat-c-image-gallery-thumbnail', {
      'cat-c-small': this.checkSmallVariant === true,
      'cat-c-image-gallery-thumbnail--vertical': this.position === 'vertical'
    });

    return html`
      <ul part="base" role="tablist" class="${componentClassNames}">
        <slot part="part-default"></slot>
      </ul>
    `;
  }
}

if (customElements.get('cat-image-gallery-thumbnail') === undefined) {
  customElements.define('cat-image-gallery-thumbnail', BlocksImageGalleryThumbnail);
}

declare global {
  interface HTMLElementTagNameMap {
    'cat-image-gallery-thumbnail': BlocksImageGalleryThumbnail;
  }
}
